import { render, staticRenderFns } from "./realData.vue?vue&type=template&id=6fb1b866&scoped=true&"
import script from "./realData.vue?vue&type=script&lang=js&"
export * from "./realData.vue?vue&type=script&lang=js&"
import style0 from "./realData.vue?vue&type=style&index=0&id=6fb1b866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb1b866",
  null
  
)

export default component.exports